
const apiUrl = "https://marsiweb.com/padelapi/api";

export async function getUser(token) {
  const response = await fetch(`${apiUrl}/user`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.json();
}

export async function updateUser(token, { email }) {
  const response = await fetch(`${apiUrl}/user`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  });
  if (!response.ok) throw new Error("Email no valido o sin modificar");
  return response.json();
}
